import axios from 'axios';
import { getAccessToken } from '@/assets/js/auth';

export const getTeamInvitations = async (otherTeamId) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  if (otherTeamId) {
    return axios.get(`/api/team/invitation?team_id=${otherTeamId}`, settings);
  } else {
    return axios.get(`/api/team/invitation?team_id=${teamId}`, settings);
}
}

export const sendInvitation = async (data) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.post(`/api/team/invitation?team_id=${teamId}`, data, settings);
}

export const deleteTeamInvitation = async (inviteId) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.delete(`/api/team/invitation?team_id=${teamId}&invitation_id=${inviteId}`, settings);
}

export const resendTeamInvitation = async (data) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.post(`/api/team/invitation/renew?team_id=${teamId}`, data, settings);
}

export const updateInvitation = async (code, data) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.patch(`/api/team/invitation?invitation_code=${code}`, data, settings);
}
